if ($('.portfolio-nav').length > 0) {
	$('.header').addClass('portfolio_nav');

	$('.header').on('mouseenter', function() {

		$('.portfolio-nav').addClass('is-hover');
	});

	$('.header').on('mouseleave', function() {
		$('.portfolio-nav').removeClass('is-hover');
	});
}

let scroll = 0;
let portfolioNav = $('.portfolio-nav')

$(window).on('load resize scroll', () => {
	const body = $('body');
	let scrolled = $(window).scrollTop();
	let header = $('.header');
	let headerHeight = header.height();
	// let portfolioNav = $('.portfolio-nav')

	// if (portfolioNav.length > 0) {
	// 	headerHeight = headerHeight + portfolioNav.height();

	// 	scrolled > scroll && header.hasClass('is-shown')
	// 		? portfolioNav.removeClass('is-show')
	// 		: portfolioNav.addClass('is-show')

	// 	scroll = scrolled
	// }

	(scrolled > headerHeight) ? body.addClass('header-fixed') : body.removeClass('header-fixed');

	if (scrolled > headerHeight + 100) {
		header.addClass('is-shown')
		setTimeout(() => {
			header.addClass('hide-nav')
		}, 500)
	} else {
		header.removeClass('is-shown')
		setTimeout(() => {
			header.removeClass('hide-nav')
		}, 500)
	}

	if ($('.js-sticky').length > 0) {
		const sticky = $('.js-sticky');

		if (scrolled > headerHeight + 100) {
			sticky.addClass('is_show')
		} else {
			sticky.removeClass('is_show');
		}
	}
});

if ($('.portfolio-nav').length > 0) {
	document.addEventListener('touchstart', handleTouchStart, false);
	document.addEventListener('touchmove', handleTouchMove, false);

	var xDown = null;
	var yDown = null;

	function getTouches(evt) {
	  return evt.touches ||             // browser API
	         evt.originalEvent.touches; // jQuery
	}

	function handleTouchStart(evt) {
	    const firstTouch = getTouches(evt)[0];
	    xDown = firstTouch.clientX;
	    yDown = firstTouch.clientY;
	};

	function handleTouchMove(evt) {
	    if ( ! xDown || ! yDown ) {
	        return;
	    }

	    var xUp = evt.touches[0].clientX;
	    var yUp = evt.touches[0].clientY;

	    var xDiff = xDown - xUp;
	    var yDiff = yDown - yUp;

	    if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {/*most significant*/
	        if ( xDiff > 0 ) {
	            /* right swipe */
	        } else {
	            /* left swipe */
	        }
	    } else {
	        if ( yDiff > 0 ) {
	            portfolioNav.removeClass('is-show')
	        } else {
	            portfolioNav.addClass('is-show')
	        }
	    }
	    /* reset values */
	    xDown = null;
	    yDown = null;
	};
}
